<template>
  <div class="h-full detail-w mx-auto pt-20px">
    <div class="mt-30px">
      <div class="ql-container ql-snow">
        <div class="ql-editor" v-html="detailInfo.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ColumnTableApi } from '@wiz-api/workbench'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import addRequestQueue from '@/assets/js/RequestQueue'

const columnTableApi = new ColumnTableApi()

export default {
  name: 'NewsHtml',
  props: {
    data: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: 'update', // update/view   update模式不触发点击
    },
    // data: {
    //   dataSource: '', 数据来源
    //   showContent: true, 显示正文
    //   showDate: true, 显示时间
    //   showPagination: true, 显示分页
    //   showTitle: true, 显示栏目标题
    //   pageSize: 10, 展示条数
    //   showMore: false
    // }
  },
  data() {
    return {
      detailInfo: {},
      title: '富文本详情页',
      dataSource: '',
      page: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
      },
    }
  },
  methods: {
    async getTextListData() {
      const [err, res] = await addRequestQueue(() => {
        return columnTableApi.getTextColumnTable(1, 1, {
          columnId: this.data.dataSource,
          isShow: true,
        })
      })
      if (!err) {
        if (res.items.length > 0) {
          // this.detailInfo = res.items[0]
          this.getTextDataDetails(res.items[0].id)
        } else {
          this.detailInfo = {}
        }
      }
    },
    async getTextDataDetails(itemId) {
      const [err, res] = await columnTableApi.getTextColumnTableDetail(itemId)
      if (!err) {
        this.detailInfo = res
      }
    },
  },
  created() {
    if (this.data.dataSource != null && this.data.dataSource !== '') {
      this.getTextListData()
    }
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
    videoUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/`
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          if (val.dataSource !== this.dataSource) {
            if (this.data.dataSource !== undefined && this.data.dataSource !== '') {
              this.getTextListData()
            }
          }
        }
      },
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.hyperlink-color {
  color: #3b9bf0;
}
::v-deep .ql-container.ql-snow {
  border: none;
}
::v-deep .ql-align-center img {
  display: inline-block;
}
</style>
